import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const Area = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
`;

export const Steps = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  padding: 20px;
  margin-bottom: 20px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
`;

export const Sidebar = styled.div`
  width: 350px;

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const Page = styled.div`
  flex: 1;
`;

export const ContentLeft = styled.div`
  width: 100%;
  padding: 1.5rem;
  min-height: fit-content;
  background: linear-gradient(180deg, #ffffff 0%, #f9fafb 100%);
  border-radius: 0.75rem;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const BoxInputDate = styled.div`
  margin: 20px 0;
  color: #444;

  span {
    font-size: 14px;
    color: #525252;
  }

  select {
    width: 100%;
    margin-top: 10px;
    font-size: 16px;
    color: inherit;
    padding: 10px 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 1px solid #ccc;
    background-color: #f0f0f0;
    cursor: pointer;
    outline: 0;
  }
`;

export const CheckSteps = styled.div`
  margin: 40px 0;
`;

type Props = {
  color: string;
};

export const ContentStep = styled.div<Props>`
  display: flex;
  align-items: center;
  font-family: 'Inter', sans-serif;
  color: ${(props) => (props.color === '1' ? '#27ae60' : '#6b7280')};
  font-size: 0.875rem;
  font-weight: ${(props) => (props.color === '1' ? '500' : '400')};
  padding: 0.75rem 0 0.75rem 1rem;
  margin-top: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
  transition: color 0.2s ease-in-out;

  svg {
    transition: color 0.2s ease-in-out;
  }
`;

export const WhatsApp = styled.div`
  position: fixed;
  right: 1.5rem;
  bottom: 6rem;
  z-index: 999;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }

  @media screen and (max-width: 768px) {
    bottom: 5rem;
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4), 0 2px 4px rgba(0, 0, 0, 0.2);
    color: #ffffff;
    font-size: 2rem;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    animation: pulse 2s infinite;

    &:hover {
      background: linear-gradient(135deg, #2ef772 0%, #25d366 100%);
      box-shadow: 0 6px 20px rgba(37, 211, 102, 0.5), 0 4px 8px rgba(0, 0, 0, 0.3);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0) scale(0.95);
    }

    svg {
      filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
    }
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4), 0 2px 4px rgba(0, 0, 0, 0.2);
    }
    50% {
      box-shadow: 0 4px 12px rgba(37, 211, 102, 0.6), 0 2px 4px rgba(0, 0, 0, 0.2), 0 0 0 8px rgba(37, 211, 102, 0.1);
    }
    100% {
      box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4), 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  }

  @media screen and (max-width: 768px) {
    right: 1rem;
    bottom: 1rem;

    a {
      width: 56px;
      height: 56px;
      font-size: 1.75rem;
    }
  }

  @media screen and (max-width: 480px) {
    right: 0.75rem;
    bottom: 0.75rem;

    a {
      width: 52px;
      height: 52px;
      font-size: 1.5rem;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0 !important;
`;

export const RowSelectButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 1rem 0;
`;

export const SelectButton = styled.div<{ isSelect?: boolean, tr?: boolean, tl?: boolean, br?: boolean, bl?: boolean }>`
  background: ${({ isSelect }) =>
    isSelect
      ? 'linear-gradient(135deg, #27ae60 0%, #1e8e4f 100%)'
      : '#ffffff'};
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border: 2px solid ${({ isSelect }) => (isSelect ? '#27ae60' : '#e5e7eb')};
  cursor: pointer;
  border-top-left-radius: ${({ tl }) => tl ? '0.75rem' : '0'};
  border-top-right-radius: ${({ tr }) => tr ? '0.75rem' : '0'};
  border-bottom-left-radius: ${({ bl }) => bl ? '0.75rem' : '0'};
  border-bottom-right-radius: ${({ br }) => br ? '0.75rem' : '0'};
  transition: all 0.3s ease-in-out;
  box-shadow: ${({ isSelect }) =>
    isSelect
      ? '0 4px 6px rgba(39, 174, 96, 0.2)'
      : '0 1px 2px rgba(0, 0, 0, 0.05)'};

  &:hover {
    border-color: #27ae60;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  span {
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
    font-weight: 600;
    color: ${({ isSelect }) => (isSelect ? '#ffffff' : '#374151')};
    transition: color 0.2s ease-in-out;
  }
`;

export const SubscriptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  margin-top: 0.75rem;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 0.5rem;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;

    &:hover {
      background-color: #aaa;
    }
  }

  @media screen and (max-width: 760px) {
    max-height: 50vh;
    padding-right: 0.25rem;
  }
`;

export const SubscriptionItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.875rem 1rem;
  background-color: #ffffff;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  gap: 0.75rem;

  &:hover {
    border-color: #27ae60;
    background-color: #f9fafb;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(39, 174, 96, 0.12);
  }

  @media screen and (max-width: 760px) {
    padding: 0.75rem 0.5rem;
    gap: 0.5rem;
    align-items: center;
  }
`;

export const SubscriptionInfo = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem 1rem;
  flex: 1;
  min-width: 0;

  @media screen and (max-width: 760px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.375rem 0.5rem;
    width: 100%;
  }
`;

export const SubscriptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  min-width: 0;

  @media screen and (max-width: 760px) {
    gap: 0.25rem;
    flex-wrap: wrap;
  }
`;

export const SubscriptionLabel = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
  flex-shrink: 0;

  @media screen and (max-width: 760px) {
    font-size: 0.6875rem;
    min-width: auto;
  }
`;

export const SubscriptionValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #254d6b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;

  @media screen and (max-width: 760px) {
    font-size: 0.75rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const SubscriptionArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #27ae60;
  transition: transform 0.2s ease-in-out;
  flex-shrink: 0;

  ${SubscriptionItem}:hover & {
    transform: translateX(3px);
  }

  @media screen and (max-width: 760px) {
    align-self: flex-end;
  }

  svg {
    font-size: 20px;
  }
`;
